import { logger } from '@mail-core/logger';
import { APICallV4Post } from 'reactApp/api/APICall';
import { sendXray } from 'reactApp/utils/ga';
import { captureException } from 'reactApp/utils/tracer';

interface Params {
    /**
     * Путь в хомяке
     */
    home?: string;
    /**
     * Weblink id
     */
    public?: string;
}

class DocumentIdAPICall extends APICallV4Post<{ doc_id: string }, Params> {
    _method = 'document/id';
}

export const callDocumentIdAPI = async (params: Params) => {
    try {
        const res = await new DocumentIdAPICall().makeRequest(params);
        return res.data;
    } catch (err) {
        sendXray('unique-id-generation-error');
        captureException(err, { issueKey: 'documentUniqueIds' });
        logger.error(err);

        throw err;
    }
};
